import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Grid,
  Modal,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import backgroundPic from "../../../assets/images/bg.png";
import mainLogo from "../../../assets/images/logo.png";
import { fonts, themes } from "../../themes/themes";
import Loader from "../../Lottifiers/Loader/Loader";

interface Props {
  data: any;
  setCallBackData: (pswrd: string) => void;
  isModalOpen: boolean;
  closeModal: any;
  isLoading: boolean;
  trans?: any;
}
const StyledTextField = styled(TextField)({
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#00000041",
    borderRadius: "2em",
    color: themes.primary,
    border: "0px",
  },
  "& input": {
    fontSize: "0.85em",
    fontFamily: "Lato",
    borderRadius: "6px",
    backgroundColor: "#FFFFFF41",
    border: "0px",
    color: "white",
  },
});
const EmployeeLockScreenPresenter: React.FC<Props> = ({
  data,
  setCallBackData,
  closeModal,
  isModalOpen,
  isLoading,
  trans,
}) => {
  const [pswrd, setPswrd] = useState<string>("");

  //--->>> EMP LOCK SCREEN
  return (
    <Modal open={isModalOpen} onClose={closeModal} disableEscapeKeyDown={true}>
      <Grid
        container
        style={{
          backgroundImage: `url(${backgroundPic})`,
          position: "relative",
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Grid
          item
          xs={7}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src={mainLogo} />
        </Grid>
        <Grid
          className="User-name"
          item
          xs={4}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar
            src={data.profile_pic}
            style={{
              width: "120px",
              height: "120px",
              border: "2px solid white",
            }}
          />

          <Typography
            style={{
              color: "#FFFFFF",
              fontFamily: fonts.fontFamily,
              fontSize: "20px",
              marginTop: "0.5em",
              fontWeight: "bold",
            }}
          >
            {data?.fullname}
          </Typography>
          <StyledTextField
            type="password"
            fullWidth={false}
            value={pswrd}
            onChange={(e: any) => setPswrd(e.target.value)}
            style={{ marginTop: "0.5em" }}
            inputProps={{
              style: {
                height: "10px",
              },
            }}
            onKeyPress={(e: any) => {
              if (e.which == 13) {
                setCallBackData(pswrd);
              }
            }}
          />
          <Typography
            style={{
              marginTop: "1em",
              fontFamily: fonts.fontFamily,
              fontSize: fonts.title,
              color: "#FFFFFF",
            }}
          >
            {trans("Enter Password")}
          </Typography>
          {isLoading && (
            <div style={{ position: "fixed", marginTop: "14em" }}>
              <Loader height={100} width={200} />
            </div>
          )}
        </Grid>
      </Grid>
    </Modal>
  );
};

export default EmployeeLockScreenPresenter;
